
export const INVOICE_TYPE_LABLE = {
    '10': 'CBS', // 货物运输服务发票
    '20': 'REBLS', // 不动产经营租赁服务
    '30': 'NOLABLE' // 非特异性的标签
};

/* 发票明细配置 */
export const invoiceDetailConfig = {
    // 货物运输服务
    'CBS': {
        columns: [
            {
                label: '项目名称',
                prop: 'projectName',
                width: '200',
                'type': 'advance',
                mustFill: true,
                require: true
            },
            {
                label: '单位',
                prop: 'unit',
                width: '110',
                mustFill: false,
                require: true
            },
            {
                label: '数量',
                prop: 'quantity',
                width: '150',
                type: 'inputNumber',
                min: 0,
                mustFill: false,
                require: true,
                verify: /^[+]{0,1}(\d+)$/,
                'errorMsg': '请输入正整数！'
            },
            {

                label: '单价',
                prop: 'unitPrice',
                width: '120',
                mustFill: false,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '金额（含税）',
                prop: 'amt',
                width: '120',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '税率',
                prop: 'taxRate',
                width: '120',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '税额',
                prop: 'taxAmt',
                width: '120',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '不含税金额',
                prop: 'fee',
                width: '120',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            }
        ]

    },
    // 不动产经营租赁服务
    'REBLS': {
        columns: [
            {
                label: '项目名称',
                prop: 'projectName',
                width: '200',
                'type': 'advance',
                mustFill: true,
                require: true
            },
            {
                label: '产权证书/不动产权证号',
                prop: 'assetCertificate',
                width: '150',
                mustFill: false,
                require: true
            },
            {
                label: '面积单位',
                prop: 'areaUnit',
                width: '150',
                mustFill: false,
                require: true
            },
            {
                label: '数量',
                prop: 'quantity',
                width: '150',
                type: 'inputNumber',
                min: 0,
                mustFill: false,
                require: true,
                verify: /^[+]{0,1}(\d+)$/,
                'errorMsg': '请输入正整数！'
            },
            {
                label: '单价',
                prop: 'unitPrice',
                width: '100',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '金额',
                prop: 'amt',
                width: '150',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '税率/征收率',
                prop: 'taxRate',
                width: '150',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '税额',
                prop: 'taxAmt',
                width: '150',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '不含税金额',
                prop: 'fee',
                width: '150',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            }
        ]

    },
    // 非特异性的标签
    'NOLABLE': {
        columns: [
            {
                label: '项目名称',
                prop: 'projectName',
                'type': 'advance',
                width: '200',
                mustFill: true,
                require: true
            },
            {
                label: '规格型号',
                prop: 'standardModel',
                width: '150',
                mustFill: false,
                require: true
            },
            {
                label: '单位',
                prop: 'unit',
                width: '110',
                mustFill: false,
                require: true
            },
            {
                label: '数量',
                prop: 'quantity',
                width: '120',
                type: 'inputNumber',
                min: 0,
                mustFill: false,
                require: true
            },
            {
                label: '单价',
                prop: 'unitPrice',
                width: '120',
                mustFill: true,
                require: true
            },
            {
                label: '金额',
                prop: 'amt',
                width: '120',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            },
            {
                label: '税率/征收率',
                prop: 'taxRate',
                width: '120',
                mustFill: true,
                require: true
            },
            {
                label: '税额',
                prop: 'taxAmt',
                width: '120',
                mustFill: true,
                require: true
            },
            {
                label: '不含税金额',
                prop: 'fee',
                width: '120',
                mustFill: true,
                require: true,
                verify: /^\d+(\.\d+)?$/
            }
        ]

    }
};

/* 发票内容配置 */
export const invoiceContentConfig = {
    // 货物运输服务
    'CBS': {
        columns: [
            {
                label: '运输工具种类',
                prop: 'transportType',
                type: 'select',
                'optionNum': 'BMS_TRANSPORT_TYPE',
                width: '150',
                mustFill: true,
                require: true
            },
            {
                label: '运输工具牌号',
                prop: 'transportPlateNo',
                width: '150',
                mustFill: false,
                require: true,
                defaultValue: ''
            },
            {
                label: '起运地',
                prop: 'placeFromAddress',
                width: '150',
                mustFill: false,
                require: true,
                defaultValue: ''
            },
            {
                label: '到达地',
                prop: 'placeToAddress',
                width: '150',
                mustFill: false,
                require: true,
                defaultValue: ''
            },
            {
                label: '运输货物名称',
                prop: 'goodsName',
                width: '150',
                mustFill: true,
                require: true
            }
        ],

        type: 'CBS'
    },
    // 不动产经营租赁服务
    'REBLS': {
        columns: [
            {
                label: '不动产地址',
                prop: 'realEstateAddress',
                mustFill: true,
                require: true,
                'width': '220'
            },
            {
                'label': '租赁期起止',
                'prop': 'rentStartAndEndDate',
                'require': true,
                'width': '140',
                'type': 'el-date-picker',
                'datePickerType': 'datetimerange',
                'mustFill': true
                // 'format': 'yyyy-MM-dd'
                // 'textFormat': 'yyyy-MM-dd'
            },
            {
                label: '跨地（市）标志',
                prop: 'crossCityFlag',
                type: 'select',
                // 'optionNum': 'BMS_YSE_NO',
                options: [
                    {
                        label: '是',
                        value: 1
                    },
                    {
                        label: '否',
                        value: 0
                    }
                ],
                width: '60',
                mustFill: true,
                require: true
            }
        ]
    }
};

/**
 * @description 根据发票类型获取发票配置
 *  */
export const getInvoiceConfigByType = (type) => {
    type = type ? type.toString() : '';
    return {
        invoiceDetailConfig: invoiceDetailConfig[INVOICE_TYPE_LABLE[type]] || {},
        invoiceContentConfig: invoiceContentConfig[INVOICE_TYPE_LABLE[type]] || {}
    };
};